import { VerticalAlignmentBasic, VerticalAlignmentBasicMore } from "../../../../src/examples/utilities/VerticalAlignment";
import * as React from 'react';
export default {
  VerticalAlignmentBasic,
  VerticalAlignmentBasicMore,
  React
};